export default __webpack_public_path__ + "static/media/ISEC2024.61e0b44b.jpg";